import { VoicemailHistoryDto } from "utils/domain/voiceMailsView/extendedVoicemailHistoryDto";
import { ExtendedVoicemailsService } from "./extendedVoicemailService";

export interface ExtendedVoicemailsApi {
    getVoicemails(agentId: string): Promise<VoicemailHistoryDto[]> ;
    updateVoicemail(voicemail: VoicemailHistoryDto): Promise<boolean>;
    deleteVoicemail(voicemail: VoicemailHistoryDto): Promise<boolean>;
}

export const extendedVoicemailService = new ExtendedVoicemailsService();